import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';

@Injectable()
export class CustomRouteReuseStrategy extends RouteReuseStrategy {
	public shouldDetach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}
	public store(route: ActivatedRouteSnapshot, detachedTree: DetachedRouteHandle): void { }
	public shouldAttach(route: ActivatedRouteSnapshot): boolean {
		return false;
	}
	public retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
		return null;
	}
	public shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {

		switch (future.data.shouldReuseRoute) {
			case true:
				return true;
				break;

			case false:
				return false;
				break;
		}

		return (future.routeConfig === curr.routeConfig) || future.data.reuse;
	}
}
